export default function () {
  return {
    guestCartNumber: null,
    guestCustomerId: null,
    guestUser: null,
    storePickupSlotId: null,
    scheduledDeliverySlotId: null,
  }
}
